<template>
	<div class="custom-node">
		<Handle
			id="targetCustomNode"
			type="target"
			:position="Position.Left"
			:connectable="handleConnectable"
		/>
		<span>{{ text }}</span>
	</div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';
import {Handle, HandleConnectableFunc, Position} from '@vue-flow/core';

export default defineComponent({
	name: 'CustomNode',
	components: {
		Handle,
	},
	props: {
		text: {
			type: String,
		},
	},
	setup() {
		const handleConnectable: HandleConnectableFunc = (node, connectedEdges) => {
			// only allow connections if the node has less than one connection
			// check if the connection is not a tree connection
			connectedEdges = connectedEdges.filter(connectedEdge => connectedEdge.data.type !== "treeConnection");
			return connectedEdges.length < 1;
		}

		return {
			Position,
			handleConnectable,
		};
	},
});

</script>

<style scoped>

.custom-node {
	height: 100%;
	width: 100%;
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
	gap: 10px;
	background: white;
	border: 1px solid black;
	border-radius: 4px;
}

</style>
